import bridge from '@vkontakte/vk-bridge';

/**
 * VK Mini App utilities
 *
 * @contract Инициализация и detection VK Mini App окружения через VK Bridge.
 *
 * Mini App признак: URL содержит vk_user_id / vk_app_id в search-params,
 * либо bridge.supports('VKWebAppInit') возвращает true.
 */

let initialized = false;
let isMiniApp: boolean | null = null;

/**
 * Проверка: запущено ли приложение внутри VK (iframe Mini App).
 * Результат кэшируется после первого вызова.
 */
export function isRunningInVkMiniApp(): boolean {
  if (isMiniApp !== null) return isMiniApp;

  const params = new URLSearchParams(window.location.search);
  const hasVkParams = params.has('vk_app_id') && params.has('vk_user_id');
  const inIframe = window.self !== window.top;

  isMiniApp = hasVkParams && inIframe;
  return isMiniApp;
}

/**
 * Отправить VKWebAppInit — обязательный первый вызов для VK Mini App.
 * Безопасно вызывать несколько раз, повторные вызовы игнорируются.
 */
export async function initVkBridgeIfMiniApp(): Promise<void> {
  if (initialized) return;
  if (!isRunningInVkMiniApp()) return;

  try {
    await bridge.send('VKWebAppInit');
    initialized = true;
  } catch (error) {
    // Bridge недоступен (браузер / не VK) — игнорируем
    console.warn('[vk-mini-app] VKWebAppInit failed:', error);
  }
}
